import { useDispatch, useSelector } from "react-redux"
import { fetchParticipants } from "../features/users/fetchParticipants"
import { useContext, useEffect, useState, useCallback } from "react"
import { viewContext } from "../context/viewContext"

export const useFetchParticipants = () => {
  const { unique_owner_id } = useContext(viewContext)
  const dispatch = useDispatch()

  const owner = useSelector(state => state.owners[unique_owner_id])

  const status = owner?.actionStatuses?.fetchParticipants?.status
  const loaded = owner?.actionStatuses?.fetchParticipants?.loaded

  const isFetching = status === 'fetching'
  const isLoading = status === 'fetching' && !loaded
  const isSuccess = status === 'success'
  const error = status === 'failed'

  const fetch = useCallback(async () => {
    await dispatch(fetchParticipants({ unique_owner_id }))
  }, [unique_owner_id, dispatch])

  return {
    isFetching,
    isLoading,
    isSuccess,
    error,
    fetch,
  }
}
